import { Backdrop, Badge } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Styles from './ChallengeExplanation.module.scss';

export const ChallengeExplanation = ({ showInfo, hideChallengeInfo, explanation, gif_link }) => {
    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={showInfo}
            onClick={hideChallengeInfo}
        >
            <Badge
                aria-label="Close Explanation"
                badgeContent={
                    <CloseIcon 
                        className={Styles.closeBadge}
                    />
                }
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                onClick={hideChallengeInfo}
            >
                <div id='challengeInfoContainer' className={Styles.challengeInfoCard}>
                    <div id='gifContainer' className={Styles.gifContainer}>
                        <img
                            src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${gif_link}`}
                            alt="challengeGif"
                            className={Styles.challengeGif} />
                    </div>
                    <div id='explanationContainer' className={Styles.explanationContainer}>
                        <div id='transcriptContainer' className={Styles.transcriptContainer}>
                            <p id="challengeDescr" className={Styles.description}>
                                {explanation ? explanation :
                                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc gravida ex eu sem dapibus, ac efficitur velit tincidunt. Quisque nec risus ac nisl congue varius. Integer sollicitudin ligula sit amet mi ullamcorper, vitae ultrices lacus ultrices. Nullam non est eget ligula fermentum eleifend. Cras pellentesque est a congue laoreet. Sed eu purus ut lorem pretium tincidunt. Fusce ultrices arcu vitae ipsum ultrices, id viverra lacus dignissim. In id risus consectetur, lobortis sem id, bibendum ipsum. Nullam ac metus malesuada, aliquet nulla ut, efficitur lectus. Pellentesque ultricies, ipsum sit amet euismod varius, nulla leo eleifend lectus, vel consectetur felis lacus id libero. Quisque fermentum mi vel eros pellentesque, vel egestas metus rutrum. Ut luctus turpis sed velit fermentum efficitur. Donec feugiat lacinia neque, vitae semper nisl aliquam et. Fusce fermentum convallis vulputate"}
                            </p>
                        </div>
                        {/* <div id='voiceContainer' className={Styles.voiceContainer}>
                            Voice Over Stuff Goes here
                        </div> */}
                    </div>
                </div>
            </Badge>
        </Backdrop>
    );
}